import { Observable } from 'rxjs';
import { inject } from '@angular/core';
import { Route } from '../enums/route';
import { RouteTitlesProviderService } from '../providers/route-titles-provider.service';

export const resolveTitleFor = (route: Route): (() => Observable<string>) => {
  return () => inject(RouteTitlesProviderService).entry(route);
};
